/**
 * @see https://developers.google.com/tag-manager/devguide#events
 */
const googleTagManagerAgent = {
  isGTMLoaded() {
    return typeof window !== 'undefined' && 'dataLayer' in window;
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  recordEvent(params: { eventName: string; variables: Record<string, any> }) {
    if (this.isGTMLoaded()) {
      window.dataLayer.push({ event: params.eventName, ...params.variables });
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  recordEcommerceEvent(params: { eventName: string; variables: Record<string, any> }) {
    if (this.isGTMLoaded()) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: params.eventName, ...params.variables });
    }
  },

  setUser({ userId }: { userId: string }) {
    if (!this.isGTMLoaded()) return;

    window.dataLayer.push({ userId });
  },

  initializeUser() {
    if (!this.isGTMLoaded()) return;

    window.dataLayer.push({ userId: null, email: null });
  },

  setDataLayerVariables(
    data: Record<string, any> // eslint-disable-line @typescript-eslint/no-explicit-any
  ) {
    if (!this.isGTMLoaded()) return;

    window.dataLayer.push(data);
  },

  /**
   * eventName을 key로 variables를 세팅합니다. `triggerDataLayerValues` 메서드로 세팅한 변수와 함께 이벤트를 기록할 수 있습니다.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setDataLayerValues({ eventName, variables }: { eventName: string; variables: any }) {
    if (!this.isGTMLoaded()) return;

    window.dataLayer.push(function set(this: Window['dataLayer']) {
      this.set(eventName, variables);
    });
  },

  /**
   * eventName을 key로 세팅한 변수와 함께 이벤트를 기록합니다. `setDataLayerValues` 메서드로 변수를 지정할 수 있습니다
   * @param eventName 조회할 변수의 키
   */
  triggerDataLayerValues(eventName: string) {
    if (!this.isGTMLoaded()) return;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let variables: any = null;

    window.dataLayer.push(function get(this: Window['dataLayer']) {
      variables = this.get(eventName);

      if (process.env.REACT_APP_MODUSIGN_ENV !== 'production') {
        if (!variables) {
          throw new Error(`${eventName} 이벤트는 지정된 컨텍스트없이 기록되고 있습니다.`);
        }
      }
    });

    window.dataLayer.push({ event: eventName, ...variables });
    window.dataLayer.push(function set(this: Window['dataLayer']) {
      this.set(eventName, null);
    });
  },
};

export default googleTagManagerAgent;
